import { CookieKeys } from "../constants/cookieKeys";

export const setCookie = (
  name: CookieKeys,
  value: string,
  maxAge: number = 604800 // 7 дней
) => {
  if (typeof document !== "undefined") {
    const secure = window.location.protocol === "https:" ? "; secure" : "";

    document.cookie = `${name}=${value}; path=/; max-age=${maxAge}; samesite=lax${secure}`;
  }
};
